export default __webpack_public_path__ + "static/char-v-17-86b614776d39974ffa57d11116f9b051.webp";